import React from 'react';
const SelectInput = (props) => {
    const { orgMetadataField, onChange, isRequired, hasRequiredError, val } = props;
    const buildOptionsList = () => {
        if (!orgMetadataField.options)
            return React.createElement(React.Fragment, null);
        const options = [...orgMetadataField.options];
        options.sort((a, b) => {
            return a.optionName.toUpperCase() > b.optionName.toUpperCase() ? 1 : -1;
        });
        return options.map((option) => {
            return (React.createElement("option", { key: `${orgMetadataField.name}-${option.optionName}`, value: option.optionName, title: orgMetadataField.name }, option.optionName));
        });
    };
    return (React.createElement("div", { className: 'form-input-group' },
        React.createElement("label", { className: 'input-label', htmlFor: orgMetadataField.name },
            orgMetadataField.name,
            " ",
            isRequired ? '*' : ''),
        React.createElement("select", { id: orgMetadataField.name, "data-testid": `test-input-${orgMetadataField.name}`, name: orgMetadataField.name, className: 'input select', value: val || 'Select', onChange: e => onChange(orgMetadataField.name, e.target.value) },
            React.createElement("option", { value: 'Select', disabled: true }, orgMetadataField.name),
            !isRequired && React.createElement("option", { value: '' }),
            buildOptionsList()),
        isRequired && hasRequiredError &&
            React.createElement("span", { className: 'required-error' }, "Required")));
};
export default SelectInput;
